import React from 'react'
import PropTypes from 'prop-types'
import ResponsiveImage from 'components/ResponsiveImage'
import Link, { LINK_BEHAVIORS, LINK_THEMES } from 'components/Link'
import './CountryPageEmployee.scss'

const CountryPageEmployee = ({
    image,
    name,
    position,
    url  
}) => {
    return (
        <div  className="country-page-employee">
            <div className="country-page-employee__image-container">
                {image && (
                    <ResponsiveImage 
                        {...image} 
                        className="responsive-image_size_country-page-employee" 
                    />
                )}
            </div>
            <div className="country-page-employee__text-container">
                {name && 
                    <div className="country-page-employee__name-holder">
                        <Link
                            url={url}
                            theme={LINK_THEMES.lightTotal}
                            text={name}
                            behavior={LINK_BEHAVIORS.text}
                        />
                    </div>
                }
                {position && <div className="country-page-employee__position">{position}</div>}
            </div>
        </div>
    )
}

CountryPageEmployee.propTypes = {
    url: PropTypes.string,
    image: PropTypes.exact(ResponsiveImage.propTypes),
    name: PropTypes.string,
    position: PropTypes.string,
}

export default CountryPageEmployee
